export const dataG = {
  "id": 348,
  "name": "Recorrido Norte Norte - Guatuso",
  "name_es": "Recorrido Norte Norte - Guatuso",
  "name_en": "Recorrido Norte Norte - Guatuso",
  "explore_mode": false,
  "slug": "norte-guatuso",
  "sponsors": [],
  "guides": [],
  "active": false,
  "url": "http://localhost",
  "guide_img_id": "icono-menu",
  "transition_sound_id": null,
  "survey_code": "",
  "colors": [
      {
          "id": 988,
          "color": {
              "id": 1475,
              "primary": "#25593b",
              "secondary": "#ffffff"
          },
          "order": 0
      },
      {
          "id": 985,
          "color": {
              "id": 1474,
              "primary": "#202945",
              "secondary": "#ffffff"
          },
          "order": 0
      },
      {
          "id": 986,
          "color": {
              "id": 1473,
              "primary": "#25593b",
              "secondary": "#edce79"
          },
          "order": 1
      },
      {
          "id": 987,
          "color": {
              "id": 1476,
              "primary": "#00f0a1",
              "secondary": "#202945"
          },
          "order": 1
      }
  ],
  "call_to_action": {
      "category": "Book",
      "mobile_redirect": "",
      "redirect": "",
      "promo_text": ""
  },
  "default_waypoint": {
      "scale": "1 1 1",
      "rig_rotation": "0 0",
      "text_color": "#202945",
      "text_scale": "1 1 1",
      "text_position": "1 1 1"
  },
  "lobby_rig_rotation": {
      "x": 0,
      "y": 0
  },
  "locations": [
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 623,
          "id": "",
          "order": 11,
          "name": "Rancho de Actividades",
          "bg_id": "ranchoref",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "ranchoactividades",
          "waypoints": [
              {
                  "id_tour_creator": 905,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 6,
                      "y_angle": -167,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Venta de Artesanías",
                  "text_es": "Venta de Artesanías",
                  "text_en": "Venta de Artesanías",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 624,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 512,
                  "has_info": false,
                  "info": "Se trata de un rancho con múltiples funciones en la comunidad, especialmente para actividades diversas. Su ubicación en una zona elevada es una ventaja para la comunidad indígena maleku y la región de Guatuso, ya que ambas son afectadas por inundaciones. El rancho puede utilizarse como albergue en caso de emergencias, brindando refugio seguro para la comunidad.",
                  "info_es": "Se trata de un rancho con múltiples funciones en la comunidad, especialmente para actividades diversas. Su ubicación en una zona elevada es una ventaja para la comunidad indígena maleku y la región de Guatuso, ya que ambas son afectadas por inundaciones. El rancho puede utilizarse como albergue en caso de emergencias, brindando refugio seguro para la comunidad.",
                  "info_en": "Se trata de un rancho con múltiples funciones en la comunidad, especialmente para actividades diversas. Su ubicación en una zona elevada es una ventaja para la comunidad indígena maleku y la región de Guatuso, ya que ambas son afectadas por inundaciones. El rancho puede utilizarse como albergue en caso de emergencias, brindando refugio seguro para la comunidad.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 5,
                      "y_angle": 166,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "ranchoref",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Rancho de Actividades",
          "name_en": "Rancho de Actividades",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 628,
          "id": "",
          "order": 16,
          "name": "Tiro con Arco",
          "bg_id": "tiroarco",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "tiro-arco",
          "waypoints": [
              {
                  "id_tour_creator": 921,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 360,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Restaurante y Artesanías",
                  "text_es": "Restaurante y Artesanías",
                  "text_en": "Restaurante y Artesanías",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 639,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 532,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 32,
                      "distance": 7
                  },
                  "title": "Explicación",
                  "title_en": "Explicación",
                  "title_es": "Explicación",
                  "sound_id": null,
                  "image_id": null,
                  "icon_id": "videoicon",
                  "video_url": "https://www.youtube.com/watch?v=S3XDqS1T2UI"
              },
              {
                  "id_tour_creator": 502,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -5,
                      "y_angle": 50,
                      "distance": 7
                  },
                  "title": "Practicando con tiro con arco",
                  "title_en": "Practicando con tiro con arco",
                  "title_es": "Practicando con tiro con arco",
                  "sound_id": null,
                  "image_id": "dsc-2085",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 528,
                  "has_info": false,
                  "info": "El arco y la flecha son elementos fundamentales en la cultura y la vida cotidiana de la comunidad maleku. Durante siglos, estas herramientas les permitieron en su tiempo cazar diferentes especies animales para obtener alimento y también protegerse de posibles amenazas. El legado ancestral de estas herramientas ha sido transmitido de generación en generación, y continúan siendo utilizadas por la comunidad indígena. \n\nEn la actualidad, los Maleku utilizan el arco y la flecha para hacer tiro al blanco y tiro a distancia, dado que la cacería ya no es permitida en Costa Rica, la práctica de tiro como actividad  deportiva les permite mantener vivos los conocimientos y habilidades relacionados con el uso de estas herramientas ancestrales.",
                  "info_es": "El arco y la flecha son elementos fundamentales en la cultura y la vida cotidiana de la comunidad maleku. Durante siglos, estas herramientas les permitieron en su tiempo cazar diferentes especies animales para obtener alimento y también protegerse de posibles amenazas. El legado ancestral de estas herramientas ha sido transmitido de generación en generación, y continúan siendo utilizadas por la comunidad indígena. \n\nEn la actualidad, los Maleku utilizan el arco y la flecha para hacer tiro al blanco y tiro a distancia, dado que la cacería ya no es permitida en Costa Rica, la práctica de tiro como actividad  deportiva les permite mantener vivos los conocimientos y habilidades relacionados con el uso de estas herramientas ancestrales.",
                  "info_en": "El arco y la flecha son elementos fundamentales en la cultura y la vida cotidiana de la comunidad maleku. Durante siglos, estas herramientas les permitieron en su tiempo cazar diferentes especies animales para obtener alimento y también protegerse de posibles amenazas. El legado ancestral de estas herramientas ha sido transmitido de generación en generación, y continúan siendo utilizadas por la comunidad indígena. \n\nEn la actualidad, los Maleku utilizan el arco y la flecha para hacer tiro al blanco y tiro a distancia, dado que la cacería ya no es permitida en Costa Rica, la práctica de tiro como actividad  deportiva les permite mantener vivos los conocimientos y habilidades relacionados con el uso de estas herramientas ancestrales.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 4,
                      "y_angle": -32,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "tiroarco",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Tiro con Arco",
          "name_en": "Tiro con Arco",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 591,
          "id": "",
          "order": 3,
          "name": "Entrada a los senderos del Volcán Tenorio",
          "bg_id": "entrada-parque-2",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "bosque_ambiente_s",
          "audio_id": "24539554-1681500951",
          "waypoints": [
              {
                  "id_tour_creator": 888,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Bifurcación de los senderos",
                  "text_es": "Bifurcación de los senderos",
                  "text_en": "Bifurcación de los senderos",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 619,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 477,
                  "has_info": false,
                  "info": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "info_es": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "info_en": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -24,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "entrada-parque-2",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Entrada a los senderos del Volcán Tenorio",
          "name_en": "Entrada a los senderos del Volcán Tenorio",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 624,
          "id": "",
          "order": 12,
          "name": "Venta de Artesanías",
          "bg_id": "artesaniasmargarita",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "v-artesanias",
          "waypoints": [
              {
                  "id_tour_creator": 906,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Crokú Y U",
                  "text_es": "Crokú Y U",
                  "text_en": "Crokú Y U",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 625,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 544,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 21,
                      "y_angle": 10,
                      "distance": 7
                  },
                  "title": "Artesanías",
                  "title_en": "Artesanías",
                  "title_es": "Artesanías",
                  "sound_id": null,
                  "image_id": "dsc-2080",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 499,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 7,
                      "y_angle": 26,
                      "distance": 7
                  },
                  "title": "Artesanías de los Maleku",
                  "title_en": "Artesanías de los Maleku",
                  "title_es": "Artesanías de los Maleku",
                  "sound_id": null,
                  "image_id": "dsc-2082",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 513,
                  "has_info": false,
                  "info": "Los Maleku son reconocidos por sus hermosas artesanías hechas a mano, que incluyen máscaras talladas en madera, cestería, ropa, joyería tradicional e instrumentos musicales  utilizados en sus ceremonias como tambores, palos de lluvia entre otros . Estas artesanías son altamente valoradas por su belleza y habilidad, y representan una parte importante de la cultura y la identidad de los maleku.",
                  "info_es": "Los Maleku son reconocidos por sus hermosas artesanías hechas a mano, que incluyen máscaras talladas en madera, cestería, ropa, joyería tradicional e instrumentos musicales  utilizados en sus ceremonias como tambores, palos de lluvia entre otros . Estas artesanías son altamente valoradas por su belleza y habilidad, y representan una parte importante de la cultura y la identidad de los maleku.",
                  "info_en": "Los Maleku son reconocidos por sus hermosas artesanías hechas a mano, que incluyen máscaras talladas en madera, cestería, ropa, joyería tradicional e instrumentos musicales  utilizados en sus ceremonias como tambores, palos de lluvia entre otros . Estas artesanías son altamente valoradas por su belleza y habilidad, y representan una parte importante de la cultura y la identidad de los maleku.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 5,
                      "y_angle": -21,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "artesaniasmargarita",
                  "icon_id": "informationtour",
                  "video_url": null
              },
              {
                  "id_tour_creator": 543,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 23,
                      "y_angle": -13,
                      "distance": 7
                  },
                  "title": "Máscaras hechas por Malekus",
                  "title_en": "Máscaras hechas por Malekus",
                  "title_es": "Máscaras hechas por Malekus",
                  "sound_id": null,
                  "image_id": "dsc-2081",
                  "icon_id": null,
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Venta de Artesanías",
          "name_en": "Venta de Artesanías",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 592,
          "id": "",
          "order": 2,
          "name": "Parque Nacional Volcan Tenorio",
          "bg_id": "entrada-arque",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "ambiente_pajaros_s",
          "audio_id": "guatuso-entradatenorio",
          "waypoints": [
              {
                  "id_tour_creator": 887,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 10,
                      "y_angle": 40,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Entrada",
                  "text_es": "Entrada",
                  "text_en": "Entrada",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 591,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 472,
                  "has_info": false,
                  "info": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "info_es": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "info_en": "El Parque Nacional Volcán Tenorio se encuentra en la Cordillera Volcánica de Guanacaste y es reconocido por su rica biodiversidad, con un bosque lluvioso que alberga una amplia variedad de especies de flora y fauna de importancia regional. Además, el área del volcán Tenorio cuenta con cuatro conos que ofrecen impresionantes vistas panorámicas, desde las cuales se pueden apreciar las extensas llanuras del Pacífico y del Caribe. Estas vistas naturales son uno de los principales atractivos de este parque y ofrecen una experiencia inolvidable para los visitantes.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 5,
                      "y_angle": -22,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "entrada-arque",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Parque Nacional Volcan Tenorio",
          "name_en": "Parque Nacional Volcan Tenorio",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 619,
          "id": "",
          "order": 4,
          "name": "Bifurcación en los senderos",
          "bg_id": "dsc-4179-panorama-panoramafinal",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "bosque_ambiente_s",
          "audio_id": null,
          "waypoints": [
              {
                  "id_tour_creator": 889,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Senderos",
                  "text_es": "Senderos",
                  "text_en": "Senderos",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 594,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Bifurcación en los senderos",
          "name_en": "Bifurcación en los senderos",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 627,
          "id": "",
          "order": 15,
          "name": "Rancho Tafa Urljif",
          "bg_id": "ranchotafaurljif",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "taja-urljif",
          "waypoints": [
              {
                  "id_tour_creator": 909,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Tiro con Arco",
                  "text_es": "Tiro con Arco",
                  "text_en": "Tiro con Arco",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 628,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 524,
                  "has_info": false,
                  "info": "El rancho Maleku Taja Urijifl, es un proyecto que nació hace aproximadamente ocho años, pero los dueños tienen experiencia desde hace más de 20 años, donde se empezó con un enfoque al turismo una generación anterior, actualmente se lleva de forma independiente, en donde se trabaja con otras familias de la comunidad. La idea principal es realizar actividades que vayan conectadas con la cultura, y también con la espiritualidad. Enfatizan mucho la conexión con nuestras tradiciones, especialmente en la actualidad, que se hace un poco complicado. La comunidad está trabajando duro para que el proyecto pueda generar ingreso y trabajo para muchas familias Maleku.",
                  "info_es": "El rancho Maleku Taja Urijifl, es un proyecto que nació hace aproximadamente ocho años, pero los dueños tienen experiencia desde hace más de 20 años, donde se empezó con un enfoque al turismo una generación anterior, actualmente se lleva de forma independiente, en donde se trabaja con otras familias de la comunidad. La idea principal es realizar actividades que vayan conectadas con la cultura, y también con la espiritualidad. Enfatizan mucho la conexión con nuestras tradiciones, especialmente en la actualidad, que se hace un poco complicado. La comunidad está trabajando duro para que el proyecto pueda generar ingreso y trabajo para muchas familias Maleku.",
                  "info_en": "El rancho Maleku Taja Urijifl, es un proyecto que nació hace aproximadamente ocho años, pero los dueños tienen experiencia desde hace más de 20 años, donde se empezó con un enfoque al turismo una generación anterior, actualmente se lleva de forma independiente, en donde se trabaja con otras familias de la comunidad. La idea principal es realizar actividades que vayan conectadas con la cultura, y también con la espiritualidad. Enfatizan mucho la conexión con nuestras tradiciones, especialmente en la actualidad, que se hace un poco complicado. La comunidad está trabajando duro para que el proyecto pueda generar ingreso y trabajo para muchas familias Maleku.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 26,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "ranchotafaurljif",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Rancho Tafa Urljif",
          "name_en": "Rancho Tafa Urljif",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 621,
          "id": "",
          "order": 9,
          "name": "Palenque Margarita",
          "bg_id": "plazapmargarita",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "plaza-m20117",
          "waypoints": [
              {
                  "id_tour_creator": 903,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Plantas Medicinales",
                  "text_es": "Plantas Medicinales",
                  "text_en": "Plantas Medicinales",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 622,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 521,
                  "has_info": false,
                  "info": "El Palenque Margarita, hogar de la comunidad Maleku, es un sitio donde se puede observar la coexistencia entre lo antiguo y lo moderno.  Se pueden apreciar casas que mantienen el estilo arquitectónico tradicional, utilizando materiales naturales y techos de palma. La comunidad Maleku mantiene sus tradiciones y conocimientos ancestrales, mismas que son posibles conocer y compartir por las personas que les visitan.",
                  "info_es": "El Palenque Margarita, hogar de la comunidad Maleku, es un sitio donde se puede observar la coexistencia entre lo antiguo y lo moderno.  Se pueden apreciar casas que mantienen el estilo arquitectónico tradicional, utilizando materiales naturales y techos de palma. La comunidad Maleku mantiene sus tradiciones y conocimientos ancestrales, mismas que son posibles conocer y compartir por las personas que les visitan.",
                  "info_en": "El Palenque Margarita, hogar de la comunidad Maleku, es un sitio donde se puede observar la coexistencia entre lo antiguo y lo moderno.  Se pueden apreciar casas que mantienen el estilo arquitectónico tradicional, utilizando materiales naturales y techos de palma. La comunidad Maleku mantiene sus tradiciones y conocimientos ancestrales, mismas que son posibles conocer y compartir por las personas que les visitan.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": -31,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "plazapmargarita",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Palenque Margarita",
          "name_en": "Palenque Margarita",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 595,
          "id": "",
          "order": 6,
          "name": "Misterios del Tenorio",
          "bg_id": "misterios-004",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "bosque_ambiente_s",
          "audio_id": null,
          "waypoints": [
              {
                  "id_tour_creator": 890,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 91,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Catarata",
                  "text_es": "Catarata",
                  "text_en": "Catarata",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 593,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Misterios del Tenorio",
          "name_en": "Misterios del Tenorio",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 590,
          "id": "",
          "order": 0,
          "name": "Lago Cote",
          "bg_id": "lagunacote",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "viento_1_s",
          "audio_id": "guatuso-cote1",
          "waypoints": [
              {
                  "id_tour_creator": 885,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": -7,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Lago a la distancia",
                  "text_es": "Lago a la distancia",
                  "text_en": "Lago a la distancia",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 615,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 458,
                  "has_info": false,
                  "info": "El lago se hizo internacionalmente conocido por un hecho muy particular y fortuito. El 4 de septiembre de 1971, durante un reconocimiento a bordo de un avión bimotor Aero Commander F680, un equipo de fotografía aérea contratado por el Instituto Geográfico Nacional de Costa Rica capturó la imagen de un aparente ovni sobre el Lago de Cote.2​ La imagen se volvió famosa y llegó a ser considerada como una de las mejores fotografías de ovnis conocidas.",
                  "info_es": "El lago se hizo internacionalmente conocido por un hecho muy particular y fortuito. El 4 de septiembre de 1971, durante un reconocimiento a bordo de un avión bimotor Aero Commander F680, un equipo de fotografía aérea contratado por el Instituto Geográfico Nacional de Costa Rica capturó la imagen de un aparente ovni sobre el Lago de Cote.2​ La imagen se volvió famosa y llegó a ser considerada como una de las mejores fotografías de ovnis conocidas.",
                  "info_en": "El lago se hizo internacionalmente conocido por un hecho muy particular y fortuito. El 4 de septiembre de 1971, durante un reconocimiento a bordo de un avión bimotor Aero Commander F680, un equipo de fotografía aérea contratado por el Instituto Geográfico Nacional de Costa Rica capturó la imagen de un aparente ovni sobre el Lago de Cote.2​ La imagen se volvió famosa y llegó a ser considerada como una de las mejores fotografías de ovnis conocidas.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 106,
                      "distance": 7
                  },
                  "title": "Costa Laguna Cote",
                  "title_en": "Costa Laguna Cote",
                  "title_es": "Costa Laguna Cote",
                  "sound_id": null,
                  "image_id": "dsc-0280",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 469,
                  "has_info": false,
                  "info": "El Lago Cote es un cráter de agua dulce ovalado  con 1.98 kilómetros cuadrados, siendo el lago natural más grande de Costa Rica.  Este atractivo, es de gran belleza escénica y por su ubicación se puede observar el Lago Arenal.  Tiene gran valor cultural para la comunidad indígena Maleku, quienes lo consideran como uno de sus sitios sagrados y espirituales. Este sitio permite al visitante conectar de forma privilegiada con la naturaleza y la energía de los volcanes Arenal y Tenorio que le rodean.",
                  "info_es": "El Lago Cote es un cráter de agua dulce ovalado  con 1.98 kilómetros cuadrados, siendo el lago natural más grande de Costa Rica.  Este atractivo, es de gran belleza escénica y por su ubicación se puede observar el Lago Arenal.  Tiene gran valor cultural para la comunidad indígena Maleku, quienes lo consideran como uno de sus sitios sagrados y espirituales. Este sitio permite al visitante conectar de forma privilegiada con la naturaleza y la energía de los volcanes Arenal y Tenorio que le rodean.",
                  "info_en": "El Lago Cote es un cráter de agua dulce ovalado  con 1.98 kilómetros cuadrados, siendo el lago natural más grande de Costa Rica.  Este atractivo, es de gran belleza escénica y por su ubicación se puede observar el Lago Arenal.  Tiene gran valor cultural para la comunidad indígena Maleku, quienes lo consideran como uno de sus sitios sagrados y espirituales. Este sitio permite al visitante conectar de forma privilegiada con la naturaleza y la energía de los volcanes Arenal y Tenorio que le rodean.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -5,
                      "y_angle": 31,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "lagunacote",
                  "icon_id": "informationtour",
                  "video_url": null
              },
              {
                  "id_tour_creator": 459,
                  "has_info": false,
                  "info": "A pesar de su belleza, las ranas venenosas son altamente tóxicas, y su veneno puede ser letal para los depredadores y para los humanos si se ingiere o entra en contacto con heridas abiertas. El veneno de las ranas venenosas se usa en la medicina tradicional de algunas culturas indígenas, y también se está estudiando su uso potencial en la medicina moderna.",
                  "info_es": "A pesar de su belleza, las ranas venenosas son altamente tóxicas, y su veneno puede ser letal para los depredadores y para los humanos si se ingiere o entra en contacto con heridas abiertas. El veneno de las ranas venenosas se usa en la medicina tradicional de algunas culturas indígenas, y también se está estudiando su uso potencial en la medicina moderna.",
                  "info_en": "A pesar de su belleza, las ranas venenosas son altamente tóxicas, y su veneno puede ser letal para los depredadores y para los humanos si se ingiere o entra en contacto con heridas abiertas. El veneno de las ranas venenosas se usa en la medicina tradicional de algunas culturas indígenas, y también se está estudiando su uso potencial en la medicina moderna.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -11,
                      "y_angle": 14,
                      "distance": 7
                  },
                  "title": "Rana flecha roja y azul",
                  "title_en": "Rana flecha roja y azul",
                  "title_es": "Rana flecha roja y azul",
                  "sound_id": null,
                  "image_id": "dsc-0368",
                  "icon_id": null,
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Lago Cote",
          "name_en": "Lago Cote",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 625,
          "id": "",
          "order": 13,
          "name": "Crokú Y U",
          "bg_id": "crokuyu",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "croku",
          "waypoints": [
              {
                  "id_tour_creator": 907,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Palenque El Sol",
                  "text_es": "Palenque El Sol",
                  "text_en": "Palenque El Sol",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 626,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 531,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 18,
                      "y_angle": -14,
                      "distance": 7
                  },
                  "title": "Ritual Maleku",
                  "title_en": "Ritual Maleku",
                  "title_es": "Ritual Maleku",
                  "sound_id": null,
                  "image_id": null,
                  "icon_id": "videoicon",
                  "video_url": "https://www.youtube.com/watch?v=Fj8Fq1CmELM"
              },
              {
                  "id_tour_creator": 508,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 150,
                      "distance": 7
                  },
                  "title": "Herramientas utilizadas por los Malekus",
                  "title_en": "Herramientas utilizadas por los Malekus",
                  "title_es": "Herramientas utilizadas por los Malekus",
                  "sound_id": null,
                  "image_id": "herramientas",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 509,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -49,
                      "y_angle": 134,
                      "distance": 7
                  },
                  "title": "Granos de Cacao",
                  "title_en": "Granos de Cacao",
                  "title_es": "Granos de Cacao",
                  "sound_id": null,
                  "image_id": "cacao",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 510,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": -172,
                      "distance": 7
                  },
                  "title": "Máscaras Tradicionales",
                  "title_en": "Máscaras Tradicionales",
                  "title_es": "Máscaras Tradicionales",
                  "sound_id": null,
                  "image_id": "mascaras",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 538,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 14,
                      "y_angle": 8,
                      "distance": 7
                  },
                  "title": "\"Bien y Usted\" en Maleku",
                  "title_en": "\"Bien y Usted\" en Maleku",
                  "title_es": "\"Bien y Usted\" en Maleku",
                  "sound_id": null,
                  "image_id": "dsc-2083",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 539,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -140,
                      "distance": 7
                  },
                  "title": "Glifo Maleku",
                  "title_en": "Glifo Maleku",
                  "title_es": "Glifo Maleku",
                  "sound_id": null,
                  "image_id": "glifo",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 540,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -100,
                      "distance": 7
                  },
                  "title": "Artesanía Maleku",
                  "title_en": "Artesanía Maleku",
                  "title_es": "Artesanía Maleku",
                  "sound_id": null,
                  "image_id": "masartesania",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 542,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -60,
                      "distance": 7
                  },
                  "title": "Rótulo del lugar",
                  "title_en": "Rótulo del lugar",
                  "title_es": "Rótulo del lugar",
                  "sound_id": null,
                  "image_id": "dsc-2074",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 556,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 28,
                      "distance": 7
                  },
                  "title": "Bienvenida en idioma Maleku",
                  "title_en": "Bienvenida en idioma Maleku",
                  "title_es": "Bienvenida en idioma Maleku",
                  "sound_id": null,
                  "image_id": null,
                  "icon_id": "videoicon",
                  "video_url": "https://www.youtube.com/watch?v=syvPnCwFx1g"
              },
              {
                  "id_tour_creator": 517,
                  "has_info": false,
                  "info": "En Croku y ú, se ofrece una variedad de experiencias culturales y turísticas. Los visitantes pueden aprender sobre plantas medicinales, explorar la comida típica costarricense y degustar la comida tradicional maleku/cabecar. Además, pueden participar en deportes tradicionales como el tiro con arco y flecha, así como aprender sobre la historia, costumbres y tradiciones maleku.\n\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y conocer sitios sagrados como el río Celeste, los humedales Caño Negro y el Lago Cote. Los visitantes pueden participar en el Tour de Cacao, donde se aprende sobre las creencias y conocimiento ancestral maleku en la producción de chocolate, además de experimentar la ceremonia de purificación a través del cacao.\nAdemás, se puede realizar un tour nocturno, donde los visitantes podrán ver bastante de la fauna nocturna, además, conocerán las creencias y tradiciones que acompañan a los Malekus al ocultarse el sol. Hay opciones de hospedaje en camping, hoteles, casas familiares y cabañas rústicas, y se ofrece la enseñanza del idioma maleku y la historia de la comunidad.\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y visitar sitios sagrados como el Río Celeste, Humedales Caño Negro y Lago Cote. Los visitantes pueden participar en el Tour de Cacao, que comparte el conocimiento ancestral sobre la producción de chocolate, y también pueden realizar un tour nocturno para apreciar la belleza nocturna de la zona. Además, hay opciones de hospedaje en camping, hotel, casas familiares o cabañas rústicas, y también se ofrece la enseñanza del idioma Maleku y la historia de la comunidad.",
                  "info_es": "En Croku y ú, se ofrece una variedad de experiencias culturales y turísticas. Los visitantes pueden aprender sobre plantas medicinales, explorar la comida típica costarricense y degustar la comida tradicional maleku/cabecar. Además, pueden participar en deportes tradicionales como el tiro con arco y flecha, así como aprender sobre la historia, costumbres y tradiciones maleku.\n\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y conocer sitios sagrados como el río Celeste, los humedales Caño Negro y el Lago Cote. Los visitantes pueden participar en el Tour de Cacao, donde se aprende sobre las creencias y conocimiento ancestral maleku en la producción de chocolate, además de experimentar la ceremonia de purificación a través del cacao.\nAdemás, se puede realizar un tour nocturno, donde los visitantes podrán ver bastante de la fauna nocturna, además, conocerán las creencias y tradiciones que acompañan a los Malekus al ocultarse el sol. Hay opciones de hospedaje en camping, hoteles, casas familiares y cabañas rústicas, y se ofrece la enseñanza del idioma maleku y la historia de la comunidad.\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y visitar sitios sagrados como el Río Celeste, Humedales Caño Negro y Lago Cote. Los visitantes pueden participar en el Tour de Cacao, que comparte el conocimiento ancestral sobre la producción de chocolate, y también pueden realizar un tour nocturno para apreciar la belleza nocturna de la zona. Además, hay opciones de hospedaje en camping, hotel, casas familiares o cabañas rústicas, y también se ofrece la enseñanza del idioma Maleku y la historia de la comunidad.",
                  "info_en": "En Croku y ú, se ofrece una variedad de experiencias culturales y turísticas. Los visitantes pueden aprender sobre plantas medicinales, explorar la comida típica costarricense y degustar la comida tradicional maleku/cabecar. Además, pueden participar en deportes tradicionales como el tiro con arco y flecha, así como aprender sobre la historia, costumbres y tradiciones maleku.\n\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y conocer sitios sagrados como el río Celeste, los humedales Caño Negro y el Lago Cote. Los visitantes pueden participar en el Tour de Cacao, donde se aprende sobre las creencias y conocimiento ancestral maleku en la producción de chocolate, además de experimentar la ceremonia de purificación a través del cacao.\nAdemás, se puede realizar un tour nocturno, donde los visitantes podrán ver bastante de la fauna nocturna, además, conocerán las creencias y tradiciones que acompañan a los Malekus al ocultarse el sol. Hay opciones de hospedaje en camping, hoteles, casas familiares y cabañas rústicas, y se ofrece la enseñanza del idioma maleku y la historia de la comunidad.\nLa comunidad también ofrece la oportunidad de aprender sobre la confección de artesanías y visitar sitios sagrados como el Río Celeste, Humedales Caño Negro y Lago Cote. Los visitantes pueden participar en el Tour de Cacao, que comparte el conocimiento ancestral sobre la producción de chocolate, y también pueden realizar un tour nocturno para apreciar la belleza nocturna de la zona. Además, hay opciones de hospedaje en camping, hotel, casas familiares o cabañas rústicas, y también se ofrece la enseñanza del idioma Maleku y la historia de la comunidad.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": -26,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "crokuyu",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Crokú Y U",
          "name_en": "Crokú Y U",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 620,
          "id": "",
          "order": 8,
          "name": "Palenque Margarita - Foto Aérea",
          "bg_id": "palenquemargarita",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "palenque-margarita",
          "waypoints": [
              {
                  "id_tour_creator": 902,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Plaza del Palenque",
                  "text_es": "Plaza del Palenque",
                  "text_en": "Plaza del Palenque",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 621,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 518,
                  "has_info": false,
                  "info": "El Palenque Margarita es un asentamiento de la comunidad indígena Maleku en Costa Rica, destacado por su arquitectura tradicional. Aunque algunas construcciones han incorporado materiales modernos, la comunidad sigue manteniendo sus tradiciones y conocimientos ancestrales. \nAdemás, esta comunidad es reconocida por preservar y enseñar la medicina tradicional de los Maleku, la cual se basa en plantas medicinales, utilizadas por la comunidad durante siglos.",
                  "info_es": "El Palenque Margarita es un asentamiento de la comunidad indígena Maleku en Costa Rica, destacado por su arquitectura tradicional. Aunque algunas construcciones han incorporado materiales modernos, la comunidad sigue manteniendo sus tradiciones y conocimientos ancestrales. \nAdemás, esta comunidad es reconocida por preservar y enseñar la medicina tradicional de los Maleku, la cual se basa en plantas medicinales, utilizadas por la comunidad durante siglos.",
                  "info_en": "El Palenque Margarita es un asentamiento de la comunidad indígena Maleku en Costa Rica, destacado por su arquitectura tradicional. Aunque algunas construcciones han incorporado materiales modernos, la comunidad sigue manteniendo sus tradiciones y conocimientos ancestrales. \nAdemás, esta comunidad es reconocida por preservar y enseñar la medicina tradicional de los Maleku, la cual se basa en plantas medicinales, utilizadas por la comunidad durante siglos.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 24,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "palenquemargarita",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Palenque Margarita - Foto Aérea",
          "name_en": "Palenque Margarita - Foto Aérea",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 622,
          "id": "",
          "order": 10,
          "name": "Tour Plantas Medicinales",
          "bg_id": "plantasmedicinales",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "bosque_ambiente_s",
          "audio_id": "plt-med-2",
          "waypoints": [
              {
                  "id_tour_creator": 904,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Rancho de Actividades",
                  "text_es": "Rancho de Actividades",
                  "text_en": "Rancho de Actividades",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 623,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 507,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": -24,
                      "distance": 7
                  },
                  "title": "Cultivos en Territorio Maleku",
                  "title_en": "Cultivos en Territorio Maleku",
                  "title_es": "Cultivos en Territorio Maleku",
                  "sound_id": null,
                  "image_id": null,
                  "icon_id": "videoicon",
                  "video_url": "https://www.youtube.com/watch?v=0eW_wRmdLoE&feature=youtu.be"
              },
              {
                  "id_tour_creator": 547,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 18,
                      "y_angle": 4,
                      "distance": 7
                  },
                  "title": "Pava Moñuda",
                  "title_en": "Pava Moñuda",
                  "title_es": "Pava Moñuda",
                  "sound_id": null,
                  "image_id": "pava",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 516,
                  "has_info": false,
                  "info": "La medicina tradicional de los Maleku se basa en el uso de plantas medicinales, las cuales han sido una parte fundamental de su cultura y han sido utilizadas por la comunidad durante siglos. Estas plantas son consideradas una parte integral de su medicina tradicional, ya que son utilizadas para tratar diversas enfermedades y dolencias. Los conocimientos sobre las propiedades medicinales de las plantas han sido transmitidos de generación en generación, a través de la enseñanza oral de los Mayores. De esta manera, se ha mantenido viva la sabiduría ancestral sobre el uso de plantas medicinales para la curación. Hoy en día, continúan utilizando estas plantas como parte de su medicina tradicional.",
                  "info_es": "La medicina tradicional de los Maleku se basa en el uso de plantas medicinales, las cuales han sido una parte fundamental de su cultura y han sido utilizadas por la comunidad durante siglos. Estas plantas son consideradas una parte integral de su medicina tradicional, ya que son utilizadas para tratar diversas enfermedades y dolencias. Los conocimientos sobre las propiedades medicinales de las plantas han sido transmitidos de generación en generación, a través de la enseñanza oral de los Mayores. De esta manera, se ha mantenido viva la sabiduría ancestral sobre el uso de plantas medicinales para la curación. Hoy en día, continúan utilizando estas plantas como parte de su medicina tradicional.",
                  "info_en": "La medicina tradicional de los Maleku se basa en el uso de plantas medicinales, las cuales han sido una parte fundamental de su cultura y han sido utilizadas por la comunidad durante siglos. Estas plantas son consideradas una parte integral de su medicina tradicional, ya que son utilizadas para tratar diversas enfermedades y dolencias. Los conocimientos sobre las propiedades medicinales de las plantas han sido transmitidos de generación en generación, a través de la enseñanza oral de los Mayores. De esta manera, se ha mantenido viva la sabiduría ancestral sobre el uso de plantas medicinales para la curación. Hoy en día, continúan utilizando estas plantas como parte de su medicina tradicional.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 24,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "plantasmedicinales",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Tour Plantas Medicinales",
          "name_en": "Tour Plantas Medicinales",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 593,
          "id": "",
          "order": 7,
          "name": "Catarata del Volcan Tenorio",
          "bg_id": "catarata004",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "lluvia_s",
          "audio_id": "guatuso-cascada",
          "waypoints": [
              {
                  "id_tour_creator": 919,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 360,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Palenque Margarita",
                  "text_es": "Palenque Margarita",
                  "text_en": "Palenque Margarita",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 620,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 473,
                  "has_info": false,
                  "info": "La cascada de agua es uno de los mayores atractivos naturales de la zona, conocida por su impresionante coloración azul y una caída de aproximadamente 30 metros de altura. Es un espectáculo visual sorprendente para los visitantes, que se maravillan con su belleza escénica. Pero no solo es un lugar de gran interés turístico, sino que también ofrece un ambiente relajante para aquellos que buscan escapar del bullicio de la ciudad.",
                  "info_es": "La cascada de agua es uno de los mayores atractivos naturales de la zona, conocida por su impresionante coloración azul y una caída de aproximadamente 30 metros de altura. Es un espectáculo visual sorprendente para los visitantes, que se maravillan con su belleza escénica. Pero no solo es un lugar de gran interés turístico, sino que también ofrece un ambiente relajante para aquellos que buscan escapar del bullicio de la ciudad.",
                  "info_en": "La cascada de agua es uno de los mayores atractivos naturales de la zona, conocida por su impresionante coloración azul y una caída de aproximadamente 30 metros de altura. Es un espectáculo visual sorprendente para los visitantes, que se maravillan con su belleza escénica. Pero no solo es un lugar de gran interés turístico, sino que también ofrece un ambiente relajante para aquellos que buscan escapar del bullicio de la ciudad.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": 55,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "catarata-tenorio",
                  "icon_id": "informationtour",
                  "video_url": null
              },
              {
                  "id_tour_creator": 491,
                  "has_info": false,
                  "info": "Además, para los Maleku, este lugar tiene un gran valor cultural y espiritual. Es considerado un lugar sagrado donde muchos de sus ancestros van a vivir por la eternidad y se comunican con sus familiares en la tierra para proteger el equilibrio natural de la vida. La cascada es un lugar especial para los Maleku por su ubicación elevada, lo que sugiere que muchas almas de sus ancestros habitan allí, observando desde lo alto.",
                  "info_es": "Además, para los Maleku, este lugar tiene un gran valor cultural y espiritual. Es considerado un lugar sagrado donde muchos de sus ancestros van a vivir por la eternidad y se comunican con sus familiares en la tierra para proteger el equilibrio natural de la vida. La cascada es un lugar especial para los Maleku por su ubicación elevada, lo que sugiere que muchas almas de sus ancestros habitan allí, observando desde lo alto.",
                  "info_en": "Además, para los Maleku, este lugar tiene un gran valor cultural y espiritual. Es considerado un lugar sagrado donde muchos de sus ancestros van a vivir por la eternidad y se comunican con sus familiares en la tierra para proteger el equilibrio natural de la vida. La cascada es un lugar especial para los Maleku por su ubicación elevada, lo que sugiere que muchas almas de sus ancestros habitan allí, observando desde lo alto.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": 31,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "catarata-tenorio",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Catarata del Volcan Tenorio",
          "name_en": "Catarata del Volcan Tenorio",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 594,
          "id": "",
          "order": 5,
          "name": "Senderos del Volcan Tenorio",
          "bg_id": "senderos-tenorio-2",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "pajaros_bosque_s",
          "audio_id": "guatuso-senderos",
          "waypoints": [
              {
                  "id_tour_creator": 842,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -1,
                      "distance": 5
                  },
                  "scale": "1 1 1",
                  "text": "Misterios del Tenorio",
                  "text_es": "Misterios del Tenorio",
                  "text_en": "Misterios del Tenorio",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 595,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 476,
                  "has_info": false,
                  "info": "El Parque cuenta con una característica impresionante, el estrecho natural, que se extiende por 3,2 km y alberga varios de sus principales atractivos turísticos, como el pozo azul, los borbollones y El Teñidero. Estos lugares ofrecen la oportunidad de apreciar la belleza natural del lugar y la riqueza de su biodiversidad, convirtiendo la visita en una experiencia inolvidable.",
                  "info_es": "El Parque cuenta con una característica impresionante, el estrecho natural, que se extiende por 3,2 km y alberga varios de sus principales atractivos turísticos, como el pozo azul, los borbollones y El Teñidero. Estos lugares ofrecen la oportunidad de apreciar la belleza natural del lugar y la riqueza de su biodiversidad, convirtiendo la visita en una experiencia inolvidable.",
                  "info_en": "El Parque cuenta con una característica impresionante, el estrecho natural, que se extiende por 3,2 km y alberga varios de sus principales atractivos turísticos, como el pozo azul, los borbollones y El Teñidero. Estos lugares ofrecen la oportunidad de apreciar la belleza natural del lugar y la riqueza de su biodiversidad, convirtiendo la visita en una experiencia inolvidable.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": -31,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "senderos-tenorio-2",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Senderos del Volcan Tenorio",
          "name_en": "Senderos del Volcan Tenorio",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 615,
          "id": "",
          "order": 1,
          "name": "Lago Cote a la distancia",
          "bg_id": "dsc-4122-panorama-panoramafinal",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "viento_1_s",
          "audio_id": "g-lagocote",
          "waypoints": [
              {
                  "id_tour_creator": 886,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 2,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Parque Nacional Volcán Tenorio",
                  "text_es": "Parque Nacional Volcán Tenorio",
                  "text_en": "Parque Nacional Volcán Tenorio",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 592,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 460,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 143,
                      "distance": 7
                  },
                  "title": "Pueblo a la orilla del Arenal",
                  "title_en": "Pueblo a la orilla del Arenal",
                  "title_es": "Pueblo a la orilla del Arenal",
                  "sound_id": null,
                  "image_id": "costa-arenal",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 498,
                  "has_info": false,
                  "info": "Los Maleku consideran el Lago Cote un lugar sagrado donde muchos de sus ancestros habitan. Creen que este lugar es la morada de un hombre muy especial que luchó con los Maleku en todos sus enfrentamientos, y que se fue a vivir ahí por la eternidad en vida. Se dice que este hombre no murió y habita en ese lugar junto con todos los ancestros que han decidido ir a vivir allí después de su muerte.",
                  "info_es": "Los Maleku consideran el Lago Cote un lugar sagrado donde muchos de sus ancestros habitan. Creen que este lugar es la morada de un hombre muy especial que luchó con los Maleku en todos sus enfrentamientos, y que se fue a vivir ahí por la eternidad en vida. Se dice que este hombre no murió y habita en ese lugar junto con todos los ancestros que han decidido ir a vivir allí después de su muerte.",
                  "info_en": "Los Maleku consideran el Lago Cote un lugar sagrado donde muchos de sus ancestros habitan. Creen que este lugar es la morada de un hombre muy especial que luchó con los Maleku en todos sus enfrentamientos, y que se fue a vivir ahí por la eternidad en vida. Se dice que este hombre no murió y habita en ese lugar junto con todos los ancestros que han decidido ir a vivir allí después de su muerte.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 34,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "dsc-4122-panorama-panoramafinal",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Lago Cote a la distancia",
          "name_en": "Lago Cote a la distancia",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 639,
          "id": "",
          "order": 17,
          "name": "Restaurante y Artesanías",
          "bg_id": "restaurantearts",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "ambiente_pajaros_s",
          "audio_id": "restaurante-artes",
          "waypoints": [
              {
                  "id_tour_creator": 920,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": 66,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Tonjibe",
                  "text_es": "Tonjibe",
                  "text_en": "Tonjibe",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 630,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 548,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": -18,
                      "distance": 7
                  },
                  "title": "Preparación de hojas de Bijagua",
                  "title_en": "Preparación de hojas de Bijagua",
                  "title_es": "Preparación de hojas de Bijagua",
                  "sound_id": null,
                  "image_id": "bijagua",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 549,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": -37,
                      "distance": 7
                  },
                  "title": "Preparación de un platillo tradicional",
                  "title_en": "Preparación de un platillo tradicional",
                  "title_es": "Preparación de un platillo tradicional",
                  "sound_id": null,
                  "image_id": "preparacion",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 550,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": -53,
                      "distance": 7
                  },
                  "title": "Platillo preparado",
                  "title_en": "Platillo preparado",
                  "title_es": "Platillo preparado",
                  "sound_id": null,
                  "image_id": "preparado",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 529,
                  "has_info": false,
                  "info": "Esta comunidad indigena, mantiene prácticas ancestrales en la preparación y cocción de sus alimentos, los visitantes podrán probar platillos  como: las carnes al humo,  la tradicional mafuriseca, que consiste en un pescado envuelto en hoja de anísillo y cocinado al calor de la fogata, usualmente se acompaña de yuca, o  banano frito. La bebida más representativa es una especie de horchata elaborada a base de maíz que resulta sorprendente y refrescante.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores Maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.",
                  "info_es": "Esta comunidad indigena, mantiene prácticas ancestrales en la preparación y cocción de sus alimentos, los visitantes podrán probar platillos  como: las carnes al humo,  la tradicional mafuriseca, que consiste en un pescado envuelto en hoja de anísillo y cocinado al calor de la fogata, usualmente se acompaña de yuca, o  banano frito. La bebida más representativa es una especie de horchata elaborada a base de maíz que resulta sorprendente y refrescante.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores Maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.",
                  "info_en": "Esta comunidad indigena, mantiene prácticas ancestrales en la preparación y cocción de sus alimentos, los visitantes podrán probar platillos  como: las carnes al humo,  la tradicional mafuriseca, que consiste en un pescado envuelto en hoja de anísillo y cocinado al calor de la fogata, usualmente se acompaña de yuca, o  banano frito. La bebida más representativa es una especie de horchata elaborada a base de maíz que resulta sorprendente y refrescante.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.\nAdemás de la comida, en el rancho también se pueden comprar artesanías hechas por los propios pobladores Maleku. Las artesanías están elaboradas con materiales naturales, como la fibra de palma, semillas y madera. Entre las artesanías que se pueden encontrar están las máscaras, los instrumentos musicales, las bolsas tejidas y las esculturas de animales.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "restaurantearts",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Restaurante y Artesanías",
          "name_en": "Restaurante y Artesanías",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 626,
          "id": "",
          "order": 14,
          "name": "Palenque El Sol",
          "bg_id": "palenqueelsol",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "viento_1_s",
          "audio_id": "p-elsol2",
          "waypoints": [
              {
                  "id_tour_creator": 908,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 2,
                      "y_angle": 20,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Rancho Tafa Urljif",
                  "text_es": "Rancho Tafa Urljif",
                  "text_en": "Rancho Tafa Urljif",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 627,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 555,
                  "has_info": false,
                  "info": "El Palenque El Sol, a pesar de ser el más pequeño de los tres, ha logrado mantener su cultura gracias a la importancia que otorga a su entorno natural. Los ranchos multifamiliares ubicados a lo largo de las riberas de los ríos, muy cerca de la confluencia con algunos de sus pequeños afluentes, permiten que la comunidad tenga acceso al agua, lo que resulta crucial para sus prácticas culturales y cotidianas. En este sitio encontramos a Hiqui Morera Castro, una mujer con gran riqueza cultural, quien acompaña  a las personas visitantes a sumergirse en la cultura indígena y aprender de primera mano sobre la vida en un palenque. Con ella, realizan actividades culturales, como talleres de artesanías, competencias de arco y flecha, ceremonias y charlas de cultura.",
                  "info_es": "El Palenque El Sol, a pesar de ser el más pequeño de los tres, ha logrado mantener su cultura gracias a la importancia que otorga a su entorno natural. Los ranchos multifamiliares ubicados a lo largo de las riberas de los ríos, muy cerca de la confluencia con algunos de sus pequeños afluentes, permiten que la comunidad tenga acceso al agua, lo que resulta crucial para sus prácticas culturales y cotidianas. En este sitio encontramos a Hiqui Morera Castro, una mujer con gran riqueza cultural, quien acompaña  a las personas visitantes a sumergirse en la cultura indígena y aprender de primera mano sobre la vida en un palenque. Con ella, realizan actividades culturales, como talleres de artesanías, competencias de arco y flecha, ceremonias y charlas de cultura.",
                  "info_en": "El Palenque El Sol, a pesar de ser el más pequeño de los tres, ha logrado mantener su cultura gracias a la importancia que otorga a su entorno natural. Los ranchos multifamiliares ubicados a lo largo de las riberas de los ríos, muy cerca de la confluencia con algunos de sus pequeños afluentes, permiten que la comunidad tenga acceso al agua, lo que resulta crucial para sus prácticas culturales y cotidianas. En este sitio encontramos a Hiqui Morera Castro, una mujer con gran riqueza cultural, quien acompaña  a las personas visitantes a sumergirse en la cultura indígena y aprender de primera mano sobre la vida en un palenque. Con ella, realizan actividades culturales, como talleres de artesanías, competencias de arco y flecha, ceremonias y charlas de cultura.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 60,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "palenqueelsol",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Palenque El Sol",
          "name_en": "Palenque El Sol",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 632,
          "id": "",
          "order": 20,
          "name": "Montaña Sagrada",
          "bg_id": "msagrada",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "sagrada2",
          "waypoints": [
              {
                  "id_tour_creator": 912,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Plaza de Tonjibe",
                  "text_es": "Plaza de Tonjibe",
                  "text_en": "Plaza de Tonjibe",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 633,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 500,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 18,
                      "y_angle": -40,
                      "distance": 7
                  },
                  "title": "Zopilote Rey (Sarcoramphus Papa)",
                  "title_en": "Zopilote Rey (Sarcoramphus Papa)",
                  "title_es": "Zopilote Rey (Sarcoramphus Papa)",
                  "sound_id": null,
                  "image_id": "dsc-2153-2",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 501,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -1,
                      "y_angle": 29,
                      "distance": 7
                  },
                  "title": "Ritual en la Montaña Sagrada",
                  "title_en": "Ritual en la Montaña Sagrada",
                  "title_es": "Ritual en la Montaña Sagrada",
                  "sound_id": null,
                  "image_id": "dsc-2196",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 545,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 26,
                      "y_angle": 15,
                      "distance": 7
                  },
                  "title": "Tucán",
                  "title_en": "Tucán",
                  "title_es": "Tucán",
                  "sound_id": null,
                  "image_id": "dsc-2070",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 546,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 23,
                      "y_angle": -12,
                      "distance": 7
                  },
                  "title": "Tucán aleteando",
                  "title_en": "Tucán aleteando",
                  "title_es": "Tucán aleteando",
                  "sound_id": null,
                  "image_id": "dsc-2072",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 515,
                  "has_info": false,
                  "info": "Entre los sitios sagrados para los Maleku se encuentran los cerros, ríos y árboles antiguos que se consideran morada de los espíritus de sus antepasados.  El conocimiento de estos sitios sagrados y su relación con el mundo natural es transmitido de generación en generación a través de historias, canciones y rituales. Esta comunidad viene trabajando con organizaciones y grupos internacionales para proteger y preservar estos lugares sagrados, así como para promover la conciencia y la comprensión de su cultura y cosmovisión.",
                  "info_es": "Entre los sitios sagrados para los Maleku se encuentran los cerros, ríos y árboles antiguos que se consideran morada de los espíritus de sus antepasados.  El conocimiento de estos sitios sagrados y su relación con el mundo natural es transmitido de generación en generación a través de historias, canciones y rituales. Esta comunidad viene trabajando con organizaciones y grupos internacionales para proteger y preservar estos lugares sagrados, así como para promover la conciencia y la comprensión de su cultura y cosmovisión.",
                  "info_en": "Entre los sitios sagrados para los Maleku se encuentran los cerros, ríos y árboles antiguos que se consideran morada de los espíritus de sus antepasados.  El conocimiento de estos sitios sagrados y su relación con el mundo natural es transmitido de generación en generación a través de historias, canciones y rituales. Esta comunidad viene trabajando con organizaciones y grupos internacionales para proteger y preservar estos lugares sagrados, así como para promover la conciencia y la comprensión de su cultura y cosmovisión.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 3,
                      "y_angle": -23,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "msagrada",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Montaña Sagrada",
          "name_en": "Montaña Sagrada",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 636,
          "id": "",
          "order": 24,
          "name": "Quiosco del Parque de San Rafael",
          "bg_id": "quiosco",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": null,
          "waypoints": [
              {
                  "id_tour_creator": 916,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Iglesia de San Rafael",
                  "text_es": "Iglesia de San Rafael",
                  "text_en": "Iglesia de San Rafael",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 637,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Quiosco del Parque de San Rafael",
          "name_en": "Quiosco del Parque de San Rafael",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 633,
          "id": "",
          "order": 21,
          "name": "Palenque Tonjibe",
          "bg_id": "plaza",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": null,
          "waypoints": [
              {
                  "id_tour_creator": 913,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "San Rafael de Guatuso",
                  "text_es": "San Rafael de Guatuso",
                  "text_en": "San Rafael de Guatuso",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 634,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Palenque Tonjibe",
          "name_en": "Palenque Tonjibe",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 635,
          "id": "",
          "order": 23,
          "name": "Estatua Maleku",
          "bg_id": "estatua",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": "ambiente_ciudad_s",
          "audio_id": null,
          "waypoints": [
              {
                  "id_tour_creator": 915,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Quiosco del Parque",
                  "text_es": "Quiosco del Parque",
                  "text_en": "Quiosco del Parque",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 636,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Estatua Maleku",
          "name_en": "Estatua Maleku",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 634,
          "id": "",
          "order": 22,
          "name": "San Rafael de Guatuso",
          "bg_id": "sanrafaelg",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "sfguatuso",
          "waypoints": [
              {
                  "id_tour_creator": 914,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Estatua Indígena",
                  "text_es": "Estatua Indígena",
                  "text_en": "Estatua Indígena",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 635,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 519,
                  "has_info": false,
                  "info": "San Rafael de Guatuso es un distrito del cantón de Guatuso, ubicado en la provincia de Alajuela, Costa Rica. El distrito cuenta con una población de alrededor de 5,000 habitantes y su economía se basa principalmente en la agricultura y la ganadería.",
                  "info_es": "San Rafael de Guatuso es un distrito del cantón de Guatuso, ubicado en la provincia de Alajuela, Costa Rica. El distrito cuenta con una población de alrededor de 5,000 habitantes y su economía se basa principalmente en la agricultura y la ganadería.",
                  "info_en": "San Rafael de Guatuso es un distrito del cantón de Guatuso, ubicado en la provincia de Alajuela, Costa Rica. El distrito cuenta con una población de alrededor de 5,000 habitantes y su economía se basa principalmente en la agricultura y la ganadería.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 2,
                      "y_angle": 25,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "sanrafaelg",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "San Rafael de Guatuso",
          "name_en": "San Rafael de Guatuso",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 637,
          "id": "",
          "order": 25,
          "name": "Iglesia de San Rafael Arcangel",
          "bg_id": "iglesia",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "iglesiasf",
          "waypoints": [
              {
                  "id_tour_creator": 917,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -3,
                      "y_angle": -117,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Hacia Rio Frío",
                  "text_es": "Hacia Rio Frío",
                  "text_en": "Hacia Rio Frío",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 638,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 522,
                  "has_info": false,
                  "info": "La Iglesia de San Rafael Arcángel en Guatuso es el Templo Parroquial, dedicado a San Rafael Arcángel. La iglesia original fue declarada coadjutoría en 1949, y en 1967 se construyó el templo actual. La Parroquia de San Rafael se erigió en 1970, durante el episcopado de monseñor Román Arrieta Villalobos, Primer obispo de Tilarán. Actualmente, la parroquia es sufragánea de la diócesis de Ciudad Quesada de la provincia eclesiástica de Costa Rica.",
                  "info_es": "La Iglesia de San Rafael Arcángel en Guatuso es el Templo Parroquial, dedicado a San Rafael Arcángel. La iglesia original fue declarada coadjutoría en 1949, y en 1967 se construyó el templo actual. La Parroquia de San Rafael se erigió en 1970, durante el episcopado de monseñor Román Arrieta Villalobos, Primer obispo de Tilarán. Actualmente, la parroquia es sufragánea de la diócesis de Ciudad Quesada de la provincia eclesiástica de Costa Rica.",
                  "info_en": "La Iglesia de San Rafael Arcángel en Guatuso es el Templo Parroquial, dedicado a San Rafael Arcángel. La iglesia original fue declarada coadjutoría en 1949, y en 1967 se construyó el templo actual. La Parroquia de San Rafael se erigió en 1970, durante el episcopado de monseñor Román Arrieta Villalobos, Primer obispo de Tilarán. Actualmente, la parroquia es sufragánea de la diócesis de Ciudad Quesada de la provincia eclesiástica de Costa Rica.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": -2,
                      "y_angle": -81,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "iglesia",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Iglesia de San Rafael Arcangel",
          "name_en": "Iglesia de San Rafael Arcangel",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 638,
          "id": "",
          "order": 26,
          "name": "Hacia Rio Frío",
          "bg_id": "riofrio",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "hriofrio",
          "waypoints": [
              {
                  "id_tour_creator": 918,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 1,
                      "y_angle": -40,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Regresar",
                  "text_es": "Regresar",
                  "text_en": "Regresar",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 590,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 523,
                  "has_info": false,
                  "info": "El río Frío es un río ubicado en Costa Rica, que tiene una longitud aproximada de 240 km. Se origina en las montañas del norte del país y fluye hacia el noreste, desembocando en el mar Caribe.\nRio Frio nace en las faldas del Volcán Tenorio, y como particularidad, pasa por la ciudad de San Rafael de Guatuso.",
                  "info_es": "El río Frío es un río ubicado en Costa Rica, que tiene una longitud aproximada de 240 km. Se origina en las montañas del norte del país y fluye hacia el noreste, desembocando en el mar Caribe.\nRio Frio nace en las faldas del Volcán Tenorio, y como particularidad, pasa por la ciudad de San Rafael de Guatuso.",
                  "info_en": "El río Frío es un río ubicado en Costa Rica, que tiene una longitud aproximada de 240 km. Se origina en las montañas del norte del país y fluye hacia el noreste, desembocando en el mar Caribe.\nRio Frio nace en las faldas del Volcán Tenorio, y como particularidad, pasa por la ciudad de San Rafael de Guatuso.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": -9,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "riofrio",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Hacia Rio Frío",
          "name_en": "Hacia Rio Frío",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 630,
          "id": "",
          "order": 18,
          "name": "Tojibachaconhe (Tonjibe)",
          "bg_id": "tonjibe",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "tonjibe2",
          "waypoints": [
              {
                  "id_tour_creator": 910,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Rancho Tojijifuru",
                  "text_es": "Rancho Tojijifuru",
                  "text_en": "Rancho Tojijifuru",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 631,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 514,
                  "has_info": false,
                  "info": "El Palenque Tonjibe es el pueblo más grande de los Maleku, y allí es donde nacieron y crecieron la mayoría de la población, por lo que sienten un arraigo grande a este Palenque. La comunidad es unida y está dispuesta a ayudar, y su cultura y tradiciones se mantienen vivas a través de la preservación de los sitios sagrados y la transmisión del conocimiento ancestral.",
                  "info_es": "El Palenque Tonjibe es el pueblo más grande de los Maleku, y allí es donde nacieron y crecieron la mayoría de la población, por lo que sienten un arraigo grande a este Palenque. La comunidad es unida y está dispuesta a ayudar, y su cultura y tradiciones se mantienen vivas a través de la preservación de los sitios sagrados y la transmisión del conocimiento ancestral.",
                  "info_en": "El Palenque Tonjibe es el pueblo más grande de los Maleku, y allí es donde nacieron y crecieron la mayoría de la población, por lo que sienten un arraigo grande a este Palenque. La comunidad es unida y está dispuesta a ayudar, y su cultura y tradiciones se mantienen vivas a través de la preservación de los sitios sagrados y la transmisión del conocimiento ancestral.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 28,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "tonjibe",
                  "icon_id": "informationtour",
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Tojibachaconhe (Tonjibe)",
          "name_en": "Tojibachaconhe (Tonjibe)",
          "lines": []
      },
      {
          "default_rotation": {
              "x": "0.0",
              "y": "0.0"
          },
          "id_tour_creator": 631,
          "id": "",
          "order": 19,
          "name": "Rancho Tojijifuru",
          "bg_id": "tojijifuru",
          "bg_type": "img",
          "has_info": false,
          "description": "",
          "page_url": "",
          "video_id": null,
          "sound_id": null,
          "audio_id": "tojijifuru2",
          "waypoints": [
              {
                  "id_tour_creator": 911,
                  "is_premium": false,
                  "use_default": true,
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 0,
                      "distance": 7
                  },
                  "scale": "1 1 1",
                  "text": "Montaña Sagrada",
                  "text_es": "Montaña Sagrada",
                  "text_en": "Montaña Sagrada",
                  "text_position": "1 1 1",
                  "text_scale": "1 1 1",
                  "text_color": "#202945",
                  "to": 632,
                  "rig_rotation": {
                      "x": "(0,",
                      "y": "0)"
                  }
              }
          ],
          "hotspots": [
              {
                  "id_tour_creator": 520,
                  "has_info": false,
                  "info": "El Rancho Tojijifuru, cuyo nombre significa \"espíritu del jaguar\", es una iniciativa que fue desarrollada por una familia local y se inauguró en el año 2003. Gran parte de las construcciones en el rancho están hechas de palma de suita, utilizando técnicas tradicionales. El rancho ofrece una amplia variedad de actividades culturales, como tiro con flecha, exposiciones de actividades tradicionales, caminatas, clases de arte, ceremonias, observación de aves, reforestación y almuerzos.",
                  "info_es": "El Rancho Tojijifuru, cuyo nombre significa \"espíritu del jaguar\", es una iniciativa que fue desarrollada por una familia local y se inauguró en el año 2003. Gran parte de las construcciones en el rancho están hechas de palma de suita, utilizando técnicas tradicionales. El rancho ofrece una amplia variedad de actividades culturales, como tiro con flecha, exposiciones de actividades tradicionales, caminatas, clases de arte, ceremonias, observación de aves, reforestación y almuerzos.",
                  "info_en": "El Rancho Tojijifuru, cuyo nombre significa \"espíritu del jaguar\", es una iniciativa que fue desarrollada por una familia local y se inauguró en el año 2003. Gran parte de las construcciones en el rancho están hechas de palma de suita, utilizando técnicas tradicionales. El rancho ofrece una amplia variedad de actividades culturales, como tiro con flecha, exposiciones de actividades tradicionales, caminatas, clases de arte, ceremonias, observación de aves, reforestación y almuerzos.",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 23,
                      "distance": 7
                  },
                  "title": "  ",
                  "title_en": "  ",
                  "title_es": "  ",
                  "sound_id": null,
                  "image_id": "tojijifuru",
                  "icon_id": "informationtour",
                  "video_url": null
              },
              {
                  "id_tour_creator": 505,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 73,
                      "distance": 7
                  },
                  "title": "Actividades en Rancho Tojijifuru",
                  "title_en": "Actividades en Rancho Tojijifuru",
                  "title_es": "Actividades en Rancho Tojijifuru",
                  "sound_id": null,
                  "image_id": "dsc-2206",
                  "icon_id": null,
                  "video_url": null
              },
              {
                  "id_tour_creator": 541,
                  "has_info": false,
                  "info": "",
                  "info_es": "",
                  "info_en": "",
                  "position": {
                      "origin": [
                          0,
                          1.6,
                          0
                      ],
                      "x_angle": 0,
                      "y_angle": 100,
                      "distance": 7
                  },
                  "title": "Palma de Pejibaye",
                  "title_en": "Palma de Pejibaye",
                  "title_es": "Palma de Pejibaye",
                  "sound_id": null,
                  "image_id": "dsc-2210",
                  "icon_id": null,
                  "video_url": null
              }
          ],
          "trivias": [],
          "description_en": "",
          "description_es": "",
          "name_es": "Rancho Tojijifuru",
          "name_en": "Rancho Tojijifuru",
          "lines": []
      }
  ],
  "assets": [
      {
          "id_tour_creator": 349,
          "img": [
              {
                  "id": "catarata-tenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/catarata-tenorio.jpeg",
                  "id_tour_creator": 1733
              },
              {
                  "id": "icono-menu",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/Icono_Menu.png",
                  "id_tour_creator": 1737
              },
              {
                  "id": "lagunacoti",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/LagunaCOTI.jpeg",
                  "id_tour_creator": 1730
              },
              {
                  "id": "senderos-tenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/senderos-tenorio.jpeg",
                  "id_tour_creator": 1734
              },
              {
                  "id": "entrada-tenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/Entrada-tenorio.jpeg",
                  "id_tour_creator": 1731
              },
              {
                  "id": "misterio-tenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/misterio-tenorio.jpeg",
                  "id_tour_creator": 1735
              },
              {
                  "id": "volcan-tenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/volcan-tenorio.jpeg",
                  "id_tour_creator": 1732
              },
              {
                  "id": "palenquemargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/palenqueMargarita.jpeg",
                  "id_tour_creator": 1824
              },
              {
                  "id": "dsc-4122-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4122_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1766
              },
              {
                  "id": "dsc-4101-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4101_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1784
              },
              {
                  "id": "dsc-4143-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4143_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1785
              },
              {
                  "id": "dsc-4167-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4167_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1786
              },
              {
                  "id": "dsc-4126-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4126_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1787
              },
              {
                  "id": "dsc-4138-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4138_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1788
              },
              {
                  "id": "dsc-4199-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4199_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1789
              },
              {
                  "id": "lagunacote",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/lagunaCote.jpeg",
                  "id_tour_creator": 1808
              },
              {
                  "id": "catarata004",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/catarata004.jpeg",
                  "id_tour_creator": 1809
              },
              {
                  "id": "senderos-tenorio-2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/senderos-tenorio-2.jpg",
                  "id_tour_creator": 1810
              },
              {
                  "id": "misterios-004",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/misterios-004.jpg",
                  "id_tour_creator": 1811
              },
              {
                  "id": "entrada-arque",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/entrada-arque.jpeg",
                  "id_tour_creator": 1812
              },
              {
                  "id": "entrada-parque-2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/entrada-parque-2.jpeg",
                  "id_tour_creator": 1813
              },
              {
                  "id": "dsc-0280",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_0280.jpg",
                  "id_tour_creator": 1814
              },
              {
                  "id": "dsc-0368",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_0368.jpg",
                  "id_tour_creator": 1815
              },
              {
                  "id": "creo-que-este-es-el-arenal-pero-si-puedes-ver-el-arenal-desde-el-lago-cote",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/Creo_que_este_es_el_Arenal_pero_si_puedes_ver_el_Arenal_desde_el_.jpg",
                  "id_tour_creator": 1816
              },
              {
                  "id": "costa-arenal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/costa-arenal.jpg",
                  "id_tour_creator": 1817
              },
              {
                  "id": "informationtour",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/informationTour.png",
                  "id_tour_creator": 1821
              },
              {
                  "id": "dsc-4179-panorama-panoramafinal",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_4179_Panorama_PanoramaFinal.jpg",
                  "id_tour_creator": 1823
              },
              {
                  "id": "plazapmargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/plazaPMargarita.jpeg",
                  "id_tour_creator": 1825
              },
              {
                  "id": "plantasmedicinales",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/plantasMedicinales.jpeg",
                  "id_tour_creator": 1826
              },
              {
                  "id": "ranchoref",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/ranchoRef.jpg",
                  "id_tour_creator": 1827
              },
              {
                  "id": "artesaniasmargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/artesaniasMargarita.jpeg",
                  "id_tour_creator": 1828
              },
              {
                  "id": "crokuyu",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/crokuyu.jpeg",
                  "id_tour_creator": 1829
              },
              {
                  "id": "palenqueelsol",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/palenqueElSol.jpeg",
                  "id_tour_creator": 1830
              },
              {
                  "id": "ranchotafaurljif",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/RanchoTafaUrljif.jpeg",
                  "id_tour_creator": 1831
              },
              {
                  "id": "tiroarco",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/tiroArco.jpeg",
                  "id_tour_creator": 1832
              },
              {
                  "id": "tonjibe",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/tonjibe.jpeg",
                  "id_tour_creator": 1833
              },
              {
                  "id": "tojijifuru",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/tojijifuru.jpeg",
                  "id_tour_creator": 1834
              },
              {
                  "id": "msagrada",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/mSagrada.jpeg",
                  "id_tour_creator": 1835
              },
              {
                  "id": "plaza",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/plaza.jpeg",
                  "id_tour_creator": 1836
              },
              {
                  "id": "sanrafaelg",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/sanRafaelG.jpeg",
                  "id_tour_creator": 1837
              },
              {
                  "id": "estatua",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/estatua.jpeg",
                  "id_tour_creator": 1838
              },
              {
                  "id": "quiosco",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/quiosco.jpeg",
                  "id_tour_creator": 1839
              },
              {
                  "id": "iglesia",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/iglesia.jpeg",
                  "id_tour_creator": 1840
              },
              {
                  "id": "riofrio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/rioFrio.jpeg",
                  "id_tour_creator": 1841
              },
              {
                  "id": "dsc-2082",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2082.jpg",
                  "id_tour_creator": 1842
              },
              {
                  "id": "dsc-2153-2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2153-2.jpg",
                  "id_tour_creator": 1843
              },
              {
                  "id": "dsc-2196",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2196.jpg",
                  "id_tour_creator": 1844
              },
              {
                  "id": "dsc-2085",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2085.jpg",
                  "id_tour_creator": 1845
              },
              {
                  "id": "dsc-2206",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2206.jpg",
                  "id_tour_creator": 1846
              },
              {
                  "id": "foto-360-a-rea-105",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/Foto_360_Area-105.jpg",
                  "id_tour_creator": 1847
              },
              {
                  "id": "herramientas",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/herramientas.jpg",
                  "id_tour_creator": 1848
              },
              {
                  "id": "cacao",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/cacao.jpeg",
                  "id_tour_creator": 1849
              },
              {
                  "id": "mascaras",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/mascaras.jpeg",
                  "id_tour_creator": 1850
              },
              {
                  "id": "restaurantearts",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/restaurantearts.jpeg",
                  "id_tour_creator": 1851
              },
              {
                  "id": "videoicon",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/videoIcon.png",
                  "id_tour_creator": 1853
              },
              {
                  "id": "dsc-2083",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2083.jpg",
                  "id_tour_creator": 1863
              },
              {
                  "id": "glifo",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/glifo.jpeg",
                  "id_tour_creator": 1864
              },
              {
                  "id": "masartesania",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/masartesania.jpeg",
                  "id_tour_creator": 1865
              },
              {
                  "id": "dsc-2210",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2210.jpg",
                  "id_tour_creator": 1866
              },
              {
                  "id": "dsc-2074",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2074.jpg",
                  "id_tour_creator": 1867
              },
              {
                  "id": "dsc-2081",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2081.jpg",
                  "id_tour_creator": 1868
              },
              {
                  "id": "dsc-2080",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2080.jpg",
                  "id_tour_creator": 1869
              },
              {
                  "id": "dsc-2070",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2070.jpg",
                  "id_tour_creator": 1870
              },
              {
                  "id": "dsc-2072",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/DSC_2072.jpg",
                  "id_tour_creator": 1871
              },
              {
                  "id": "foto-360-a-rea-100",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/Foto_360_Area-100.jpg",
                  "id_tour_creator": 1872
              },
              {
                  "id": "pava",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/pava.jpg",
                  "id_tour_creator": 1873
              },
              {
                  "id": "bijagua",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/bijagua.jpeg",
                  "id_tour_creator": 1874
              },
              {
                  "id": "preparacion",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/preparacion.jpeg",
                  "id_tour_creator": 1875
              },
              {
                  "id": "preparado",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/image/preparado.jpeg",
                  "id_tour_creator": 1876
              }
          ],
          "sound": [
              {
                  "id": "pajaros_bosque_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/pajaros_bosque_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 584
              },
              {
                  "id": "plaza-m",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/plaza-m.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 696
              },
              {
                  "id": "bosque_ambiente_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/bosque_ambiente_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 582
              },
              {
                  "id": "viento_1_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/viento_1_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 585
              },
              {
                  "id": "lluvia_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/lluvia_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 586
              },
              {
                  "id": "ambiente_pajaros_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_pajaros_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 583
              },
              {
                  "id": "croku",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/croku.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 700
              },
              {
                  "id": "ranchoact",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ranchoAct.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 670
              },
              {
                  "id": "volcantneorioentrada-g",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/volcanTneorioEntrada-G.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 609
              },
              {
                  "id": "",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 610
              },
              {
                  "id": "",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 611
              },
              {
                  "id": "senderosvolcantenorio-g2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/senderosVolcanTenorio-G2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 612
              },
              {
                  "id": "lagunacote",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/LagunaCote.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 613
              },
              {
                  "id": "g-cascada",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/g-Cascada.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 629
              },
              {
                  "id": "g-lagocote",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/g-lagocote.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 630
              },
              {
                  "id": "g-lagocote1",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/g-lagocote1.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 631
              },
              {
                  "id": "guatuso-cote1",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/Guatuso-Cote1.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 665
              },
              {
                  "id": "guatuso-entradatenorio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/Guatuso-EntradaTenorio.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 666
              },
              {
                  "id": "guatuso-senderos",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/Guatuso-Senderos.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 667
              },
              {
                  "id": "guatuso-cascada",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/Guatuso-cascada.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 668
              },
              {
                  "id": "pmargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/pMargarita.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 669
              },
              {
                  "id": "pelsol",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/pElSol.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 671
              },
              {
                  "id": "artmargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/artMargarita.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 672
              },
              {
                  "id": "tonjibe",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tonjibe.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 673
              },
              {
                  "id": "msagrada",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/msagrada.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 674
              },
              {
                  "id": "plantasm",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/plantasM.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 675
              },
              {
                  "id": "crokuyu",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/crokuyu.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 676
              },
              {
                  "id": "sfguatuso",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/sfGuatuso.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 677
              },
              {
                  "id": "tojijifuru",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tojijifuru.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 678
              },
              {
                  "id": "plazamargarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/plazaMargarita.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 679
              },
              {
                  "id": "iglesiasf",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/iglesiaSF.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 680
              },
              {
                  "id": "hriofrio",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/hriofrio.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 681
              },
              {
                  "id": "tafaurljif",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/TafaUrljif.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 682
              },
              {
                  "id": "tiroarco",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tiroArco.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 683
              },
              {
                  "id": "restarts",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/restArts.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 684
              },
              {
                  "id": "resta-artes",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/resta-artes.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 685
              },
              {
                  "id": "ambiente_autos_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_autos_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 686
              },
              {
                  "id": "ambiente_autos_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_autos_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 687
              },
              {
                  "id": "palenque-margarita",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/palenque-margarita.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 695
              },
              {
                  "id": "ambiente_autos_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_autos_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 688
              },
              {
                  "id": "t-medicina",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/t-medicina.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 697
              },
              {
                  "id": "ambiente_ciudad_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_ciudad_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 689
              },
              {
                  "id": "ambiente_autos_s",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ambiente_autos_s.mp3",
                  "sound_type": "environment",
                  "id_tour_creator": 690
              },
              {
                  "id": "ranchoactividades",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/ranchoActividades.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 698
              },
              {
                  "id": "v-artesanias",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/v-artesanias.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 699
              },
              {
                  "id": "palenque-elsol",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/palenque-elSol.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 701
              },
              {
                  "id": "taja-urljif",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/taja-urljif.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 702
              },
              {
                  "id": "tiro-arco",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tiro-arco.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 703
              },
              {
                  "id": "restaurante-artes",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/restaurante-artes.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 704
              },
              {
                  "id": "tonjibe2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tonjibe2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 705
              },
              {
                  "id": "tojijifuru2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/tojijifuru2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 706
              },
              {
                  "id": "montana-sagrada",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/montana-sagrada.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 707
              },
              {
                  "id": "palenque-elsol2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/palenque-elsol2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 708
              },
              {
                  "id": "plaza-m20117",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/plaza-m20117.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 711
              },
              {
                  "id": "plt-med-2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/plt-med-2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 712
              },
              {
                  "id": "p-elsol2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/p-elsol2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 713
              },
              {
                  "id": "sagrada2",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/sagrada2.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 714
              },
              {
                  "id": "24539554-1681500951",
                  "src": "https://rutaturisticanortenorte.go.cr/experience/norte-guatuso/sound/24539554_1681500951.mp3",
                  "sound_type": "voice",
                  "id_tour_creator": 715
              }
          ],
          "video": []
      }
  ],
  "live_sessions": [],
  "tags": [],
  "description": "",
  "location": "",
  "banner": null,
  "link_google_maps": "",
  "thumbnail": null,
  "link_youtube": null,
  "page_guides": "http://",
  "price": 0
}
